import React from 'react';
import { withRouter } from 'react-router-dom';
import API from '../../../utils/API';
import CopyPageModal from './modals/copyPageModal';
import SectionHeader from '../../../components/views/SectionHeader';
import LoadingWizard from '../../../components/spinner/wizard';
import InputField from '../../../components/inputs/inputField';
import PagePreviewFrame from '../../../views/pages/components/pagePreviewFrame';
import SelectField from '../../../components/inputs/selectField';
import PageBuilderModal from './pageEditor'
import SectionFooter from '../../../components/views/SectionFooter';
import DeleteSinglePageModal from './modals/deleteSinglePageModal';
import RenamePageModal from './modals/renamePageModal';
import UnpublishPageModal from './modals/unpublishPageModal';
import PublishPageModal from './modals/publishPageModal';
import AddUsersToSharePage from './modals/addUsersToSharePage';
import Joyride from 'react-joyride';
import tutorials from '../../../layouts/components/tutorials';


const ENV =
	process.env.NODE_ENV === 'production'
		? window.location.href.includes('planner.simple.events') ? `https://admin-api.simple.events/` : `https://beta-api.simple.events/`
		: `http://${window.location.hostname}:5015/`;

const pageTypeOptions = [
	{ value: false, label: 'General Page' },
	{ value: true, label: 'Session Template' },
]

const pageAvailabilityOptions = [
	{ value: 'public', label: 'Public (Available to anyone)' },
	{ value: 'private', label: 'Private (Only for logged in users)' },
	{ value: 'internal', label: 'Internal (Contacts with user permissions only)' }
]
const getAvailability = (p) => p.openToPublic ? 'public' : p.internalOnly ? 'internal' : 'private'
const availabilityFields = (v) => ({ openToPublic: v === 'public', internalOnly: v === 'internal' })
class EventPage extends React.Component {
	constructor(props) {
		super(props);
		const page = props.pages.find((p) => p._id === props.match.params.page);
		this.state = {
			editorOpen: false,
			selectedPage: null,
			loading: false,
			addPageModalOpen: false,
			previewOpen: true,
			detailsOpen: true,
			page: { ...page },
			editedPage: { ...page },
			copyPagesModalOpen: false,
			selectedSection: 0,
			editing: false,
			editCount: 0,
			toggleUnpublishPage: false,
			togglePublishPage: false,
			toggleRenamePage: false,
			deletePageModalTrigger: false,
			sharePageModalOpen: false,
			runPageTutorial: false,
		};

	}

	componentWillMount() {
		const { orgId, eventId } = this.props;
		const { match: { params } } = this.props;
		this.setState({ loading: true });
		API().get(`Organizations/${orgId}/events/${eventId}/pages/${params.page}`).then((res) => {
			if (res.data) {
				this.setState({ page: { ...res.data }, editedPage: { ...res.data }, loading: false });
			}
		});
	}

	refreshIframe = () => {
		this.setState({ previewUrl: '' }, () => this.setState({ previewUrl: this.props.page.url }));
	};

	savePage = async () => {
		const { orgId, eventId, updatePage, updatePathOp } = this.props;
		const { page, editedPage } = this.state;

		await API()
			.patch(`Organizations/${orgId}/events/${eventId}/pages/${page._id}`, this.state.editedPage)
			.then((res) => {
				if (res.data) {
					/* this.props.updatePage(res.data);   */
					updatePathOp(editedPage)
					this.setState({ editedPage: res.data, page: { ...res.data }, loading: false, editing: false, }, () => {
						updatePage(this.state.editedPage)
					});
				}
			})
			.catch((e) => {
				this.setState({ loading: false, editing: false });
			});
	};



	cancelEdit = () => {
		this.setState({ editing: false, editedPage: { ...this.state.page } });
	};

	updatePage = async (updatedPage, callback) => {
		this.setState({ editedPage: { ...this.state.page, ...updatedPage }, page: { ...this.state.page, ...updatedPage } }, () => {
			this.props.updatePage(this.state.page);
			this.props.updatePathOp(this.state.editedPage)
			callback && callback();

		});
	};



	publishPage = (published, callback) => {
		const { orgId, updatePage } = this.props;
		const { page, editedPage } = this.state;


		if (editedPage.pathSlug !== '' && page.status === 'draft') {

			API().post(`Organizations/${orgId}/pages/${page._id}/publish`, { published: published }).then((res) => {
				if (res.data) {
					this.setState({ editedPage: res.data, page: { ...res.data }, loading: false, editing: false });
					updatePage && updatePage(res.data);
					callback && callback();
				}
			});
		}
		else if (editedPage.pathSlug === '' && page.status === 'draft') {
			this.togglePublishPageModal();
		}

		else if (page.status === 'published') {
			API().post(`Organizations/${orgId}/pages/${page._id}/publish`, { published: published }).then((res) => {
				if (res.data) {
					this.setState({ editedPage: res.data, page: { ...res.data }, loading: false, editing: false });
					updatePage && updatePage(res.data);
					callback && callback();
				}
			});
		}




		/* API().post(`Organizations/${orgId}/pages/${page._id}/publish`, { published: published }).then((res) => {
			if (res.data) {
				this.setState({ editedPage: res.data, page: { ...res.data }, loading: false, editing: false });
				callback && callback();
			}
		}); */

	};

	togglePageBuilder = () => {
		this.setState({ editorOpen: !this.state.editorOpen });
	};

	toggleRenamePageModal = () => {
		const { toggleRenamePage } = this.state;
		this.setState({ toggleRenamePage: !toggleRenamePage });
	};

	toggleCopyPages = () => {
		const { copyPagesModalOpen } = this.state;
		this.setState({ copyPagesModalOpen: !copyPagesModalOpen });
	};

	toggleUnpublishPageModal = () => {
		const { toggleUnpublishPage } = this.state;
		this.setState({ toggleUnpublishPage: !toggleUnpublishPage });
	}

	togglePublishPageModal = () => {
		const { togglePublishPage } = this.state;
		this.setState({ togglePublishPage: !togglePublishPage });
	}

	toggleSharePageModal = () => {
		const { sharePageModalOpen } = this.state;
		this.setState({ sharePageModalOpen: !sharePageModalOpen });
	}

	sharePage = async (shareData) => {
		const { orgId, eventId } = this.props;
		const { page } = this.state;
		try {
			const res = await API().patch(`Organizations/${orgId}/events/${eventId}/pages/${page._id}`, shareData);
			if (res.data) {
				this.setState({ editedPage: res.data, page: { ...res.data } });
			}
		} catch (e) {
			console.log(e);
		}
	}

	updateSelected = (selected) => {
		this.setState({ selectedSection: selected });
	};
	handleJoyrideCallback = (data) => {
		console.log(data);
		const { status } = data;
		const finishedStatuses = ['finished', 'skipped'];
		if (finishedStatuses.includes(status)) {
			this.setState({ runPageTutorial: false });
		}
	};

	startTour = () => {
		console.log('start tour');
		this.setState({ runPageTutorial: true });
	};

	renderSection() {
		const {
			selectedSection,
			editedPage,
			editorOpen,
		} = this.state;
		const { organization, event, eventId, orgId } = this.props;

		switch (selectedSection) {
			case 0:
				return (
					<div className='sectionBody'>
						<div className='blocksContainer'>
							<div className='sectionBlock mr-25 contained-h'>
								<h2 className='blockHeader'>Basic Information</h2>
								<InputField
									label="Description"
									placeholder="Displays in page previews when link is shared"
									value={editedPage.description}
									onChange={(e) => {
										this.setState({
											editedPage: { ...editedPage, description: e.target.value },
											editing: true
										});
									}}
								/>

								<SelectField
									label="Page Type"
									required={true}
									classes="w-100"
									placeholder="Page type"
									value={editedPage.isSessionPage ? pageTypeOptions[1] : pageTypeOptions[0]}
									onChange={(e) => {
										this.setState({
											editedPage: { ...editedPage, isSessionPage: e.value },
											editing: true
										});
									}}
									options={pageTypeOptions}
								/>
								<InputField
									subText={`https://${organization.hostname ? organization.hostname : (organization.identifier + '.simple.events')}/${event.nameSlug}/${editedPage.pathSlug}`}
									label="Address"
									required={true}
									placeholder="Unique slug for this page"
									value={editedPage.pathSlug}
									onChange={(e) => {
										this.setState({
											editedPage: { ...editedPage, pathSlug: e.target.value },
											editing: true
										});
									}}
								/>
								<SelectField
									label="Availability"
									required={true}
									classes="w-100"
									placeholder="Page availability"
									value={pageAvailabilityOptions.find((o) => o.value === getAvailability(editedPage))}
									onChange={(e) => {
										this.setState({
											editedPage: { ...editedPage, ...availabilityFields(e.value) },
											editing: true
										});
									}}
									options={pageAvailabilityOptions}
								/>


							</div>
							<div className='sectionBlock emailDesignPreview mt-20'>

								<div
									className="cardDetailsContainerPages containerTitle"
								>

									<div className='w-100'>
										<h2 className='blockHeader mt-0'>Design</h2>
										<h5 className='formFieldLabel mt-10'> Web Page Design </h5>
									</div>

									{editedPage.partials.length > 0 ? <button
										disabled={!editedPage.pathSlug}
										className={`neu min ml-a`}
										onClick={this.togglePageBuilder}
									>
										Edit Design
									</button> :

										<button
											disabled={!editedPage.pathSlug}
											className={`neu min ml-a prim`}
											onClick={this.togglePageBuilder}
										>
											Create Design
										</button>}

									{/* {editedPage.status === "published" && <button className='min neu ml-10' onClick={() => {
										window.open(`https://${organization.identifier}.simple.events/${event.nameSlug}/${editedPage.slug}`, '_blank');
									}}>
										Visit Page
									</button>} */}
								</div>

								<div
									className="emailPreview pagePreview eFrame pages flex-ac preview"
								>
									{!editorOpen && <PagePreviewFrame
										ENV={ENV}
										renderURL={`Organizations/${orgId}/events/${eventId}/pages/render/${editedPage._id}/`}
										preview={true}
										pageProperties={this.state.editedPage}
										focusedComponent={""}
										simulatedUser={{ value: this.props.account._id }}
										simulatedSession={{ value: false }}
										renderOnly={true}
										editing={this.state.editCount}
									/>}
								</div>
							</div>
						</div>
					</div>
				);
			case 1:
				return (
					<div className='sectionBody'>

					</div>
				);
			default:
				break;
		}
	}

	deletePageModalTrigger = () => {
		const { deletePageModalTrigger } = this.state;
		this.setState({ deletePageModalTrigger: !deletePageModalTrigger });
	}

	render() {
		const {
			loading,
			page,
			editedPage,
			editorOpen,
			editing,
			toggleRenamePage,
			copyPagesModalOpen,
			toggleUnpublishPage,
			togglePublishPage,
			deletePageModalTrigger,
			runPageTutorial,
			sharePageModalOpen
		} = this.state;
		const { event, eventId, orgId } = this.props;
		let currentPage = {};
		currentPage[editedPage._id] = true;
		//const publishActions = page.status == 'draft' ? [{label: 'Publish Page',onClick: () => this.publishPage(true),disabled: editing}] : [{label: 'Unpublish',onClick: () => this.publishPage(false),disabled: editing}]
		const isDraft = page.status === 'draft' ? true : false;
		return (
			<div className="sectionContainer">
				{!loading && (
					<Joyride
						callback={this.handleJoyrideCallback}
						continuous
						run={runPageTutorial}
						scrollOffset={64}
						scrollToFirstStep
						showProgress={false}
						hideCloseButton={false}
						showSkipButton
						steps={tutorials['Page']}
						styles={{
							buttonNext: {
								background: 'var(--primary)',
								border: 'var(--primary--border)',
								color: 'var(--white)',
								fontWeight: 600,
								padding: '10px 15px',
								fontSize: 14,
								width: 65,
								height: 30,
							},
							buttonSkip: {
								background: 'var()',
								border: 'var(--primary--border)',
								color: 'var(--primary)',
								fontWeight: 600,
								padding: '10px 15px',
								fontSize: 14,
							},
							buttonBack: {
								color: "#007bff",
							},

						}}
					/>
				)}

				<SectionHeader
					style={{ marginTop: page.status !== "published" ? 0 : 0 }}
					title={editedPage.title}
					status={page.status}
					breadcrumbs={[
						{
							name: event.name
						},
						{
							name: 'Pages',
						}
					]}

					subActions={
						page.status !== "published" ?
							(
								[
									{
										onClick: this.toggleRenamePageModal,
										label: <span><i className='las la-pen mr-10'></i>Rename Page</span>
									},
									{
										onClick: this.toggleCopyPages,
										label: <span><i className='las la-copy mr-10'></i>Duplicate Page</span>,
									},
									{
										onClick: this.deletePageModalTrigger,
										label: <span><i className='las la-trash mr-10'></i>Delete Page</span>,
									},
									{
										onClick: this.toggleSharePageModal,
										label: <span><i className='las la-user mr-10'></i>Add Users to Share</span>,
									},
								]
							) :

							(
								[
									{
										onClick: this.toggleRenamePageModal,
										label: <span><i className='las la-pen mr-10'></i>Rename Page</span>,
									}, {
										onClick: this.toggleCopyPages,
										label: <span><i className='las la-copy mr-10'></i>Duplicate Page</span>,
									},
									{
										onClick: this.deletePageModalTrigger,
										label: <span><i className='las la-trash mr-10'></i>Delete Page</span>,
									},
									{
										onClick: this.toggleUnpublishPageModal,
										label: <span><i className='las la-unlink mr-10'></i>Unpublish Page</span>,
									},
									{
										onClick: this.toggleSharePageModal,
										label: <span><i className='las la-user mr-10'></i>Add Users to Share</span>,
									},

								]
							)
					}
				>
					<div className='tabsContainer unsetWidth'></div>
				</SectionHeader>


				{!loading && (isDraft || !editedPage.isSessionPage) && <div className="actionButtonContainer mt-20" style={{ marginLeft: 'unset' }}>
					<div>
						<button className={`mainAction ${editing || !(editedPage.partials.length > 0) ? 'disabled pageDisabled  ' : 'prim'}`}
							disabled={editing}
							onClick={() => {
								const { organization, } = this.props;
								if (isDraft) {
									this.publishPage(isDraft);
								}
								else {
									if (organization.hostname) {
										window.open(`https://${organization.hostname}/${event.nameSlug}/${editedPage.pathSlug}`, '_blank');
									} else {
										window.open(`https://${organization.identifier}.simple.events/${event.nameSlug}/${editedPage.pathSlug}`, '_blank');
									}
								}
							}}>
							<div>{isDraft ? "Publish Page" : "View Page"}</div>
						</button>
					</div>
				</div>}


				{!loading && this.renderSection()}
				<SectionFooter updatedAt={page.updatedAt} saveEdit={this.savePage} cancelEdit={this.cancelEdit} editing={editing} lastEditedBy={editedPage.lastEditedBy} />
				<LoadingWizard text="Loading Page" loading={loading} />
				{editorOpen && <PageBuilderModal scope="event" isOpen={editorOpen} toggle={() => this.setState({ editorOpen: !editorOpen })} page={this.state.page} editedPage={this.state.editedPage} updatePage={this.updatePage} cancelEdit={this.cancelEdit} event={this.props.event}
					venue={this.props.venue}
					orgId={orgId}
					eventId={eventId} />}

				{toggleRenamePage && (
					<RenamePageModal
						isOpen={toggleRenamePage}
						page={editedPage}
						orgId={orgId}
						eventId={eventId}
						event={event}
						toggle={this.toggleRenamePageModal}
						update={this.updatePage}
						updatePathOp={this.props.updatePathOp}
					/>
				)}
				{toggleUnpublishPage && (
					<UnpublishPageModal
						isOpen={toggleUnpublishPage}
						page={editedPage}
						orgId={orgId}
						eventId={eventId}
						event={event}
						toggle={this.toggleUnpublishPageModal}
						update={this.updatePage}
						publishPage={this.publishPage}
					/>
				)}
				{togglePublishPage && (
					<PublishPageModal
						isOpen={togglePublishPage}
						page={editedPage}
						orgId={orgId}
						eventId={eventId}
						event={event}
						toggle={this.togglePublishPageModal}
						update={this.updatePage}
						publishPage={this.publishPage}
					/>
				)}
				{copyPagesModalOpen && (
					<CopyPageModal
						isOpen={copyPagesModalOpen}
						page={page} //editedPage
						orgId={orgId}
						eventId={eventId}
						event={event}
						toggle={this.toggleCopyPages}
						pages={[editedPage]}
						addPage={this.props.updateAddCopy}
						checkedPages={currentPage}
					/>
				)}

				{deletePageModalTrigger && (
					<DeleteSinglePageModal
						delete={this.deletePages}
						event={event}
						page={editedPage}
						eventId={eventId}
						isOpen={deletePageModalTrigger}
						orgId={orgId}
						toggle={this.deletePageModalTrigger}
						deleteSinglePage={this.props.deleteSinglePage}
					/>
				)}

				{sharePageModalOpen && (
					<AddUsersToSharePage
						isOpen={sharePageModalOpen}
						page={editedPage}
						orgId={orgId}
						eventId={eventId}
						toggle={this.toggleSharePageModal}
						sharePage={this.sharePage}
					/>
				)}
			</div>
		);
	}
}

export default withRouter(EventPage);
